import { useState, useEffect } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import data from '../../../data/outsourcing.json';

// JSON-LD Structured Data for Outsourcing
const jsonLdData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Outsourcing de TI",
  "alternateName": "Alocação Técnica de Profissionais",
  "url": "https://www.targetsoftware.com.br/outsourcing",
  "provider": {
    "@type": "Organization",
    "name": "Target Software",
    "url": "https://www.targetsoftware.com.br",
    "logo": "https://www.targetsoftware.com.br/assets/img/logo.png"
  },
  "description": "Serviço de outsourcing e alocação técnica com gestão completa das atividades, retenção de know-how, hunting técnico, suporte corporativo e profissionais 100% CLT com suporte contínuo de RH e TI.",
  "serviceType": "Outsourcing de TI e Alocação Técnica",
  "areaServed": {
    "@type": "Country",
    "name": "Brasil"
  },
  "audience": {
    "@type": "BusinessAudience",
    "businessSize": "SMB/Enterprise",
    "industry": "Serviços Financeiros, Mercado de Capitais, Tecnologia, Indústria, Varejo"
  },
  "offers": {
    "@type": "Offer",
    "price": "Sob consulta",
    "priceCurrency": "BRL",
    "availability": "https://schema.org/InStock"
  },
  "brand": {
    "@type": "Brand",
    "name": "Target Software"
  },
  "hasPart": [
    {
      "@type": "Service",
      "name": "Gestão das Atividades",
      "description": "Acompanhamento estrutural do trabalho dos recursos com aprimoramento técnico contínuo."
    },
    {
      "@type": "Service",
      "name": "Retenção de Know-how",
      "description": "Processos e metodologias que garantem continuidade e preservação do conhecimento."
    },
    {
      "@type": "Service",
      "name": "Gestão de Capacity",
      "description": "Balanceamento ideal entre perfis, demandas e capacidade operacional do time."
    },
    {
      "@type": "Service",
      "name": "Suporte Corporativo",
      "description": "Estrutura completa de RH e TI para suporte aos profissionais alocados."
    },
    {
      "@type": "Service",
      "name": "Hunting Técnico",
      "description": "Processos de seleção avançada para encontrar os melhores talentos do mercado."
    },
    {
      "@type": "Service",
      "name": "Preço Competitivo",
      "description": "Tabela de ratecard com valores justos e competitivos no mercado."
    },
    {
      "@type": "Service",
      "name": "100% CLT",
      "description": "Todos os colaboradores são CLT com plano de saúde, benefícios e bônus anual."
    },
    {
      "@type": "Service",
      "name": "Metodologia Target",
      "description": "Método próprio que inspira equipes e garante entregas consistentes para o cliente."
    }
  ],
  "keywords": [
    "outsourcing de TI",
    "alocação de profissionais",
    "alocação técnica",
    "hunting técnico",
    "profissionais CLT",
    "gestão de capacity",
    "squads de TI",
    "desenvolvedores terceirizados",
    "equipe dedicada",
    "terceirização de TI"
  ],
  "image": "https://www.targetsoftware.com.br/assets/img/outsourcing-banner.png"
};

const OutsourcingPage = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  const { diferenciais, cases } = data;

  const handleContactClick = () => {
    window.location.href = '/contato';
  };

  // Add JSON-LD structured data to head
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLdData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Banner */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#3E296F] via-[#5D2FB3] to-[#7C3AED]">
        <div className="absolute inset-0">
          <img 
            src="/images/produtos/outsourcing.jpg"
            alt="Outsourcing"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#3E296F]/80 to-[#3E296F]/60"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-center text-white">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium mb-6">
              <i className="ri-group-line mr-2"></i>
              Profissionais Especializados
            </div>
            <h1 className="text-5xl lg:text-7xl font-bold leading-tight mb-6">
              Outsourcing
            </h1>
            <p className="text-xl lg:text-2xl text-gray-200 max-w-4xl mx-auto mb-8 leading-relaxed">
              Alocação de profissionais especializados <br/> 
              <strong className="text-white"> com gestão ativa</strong> e 
              acompanhamento <strong className="text-white"> técnico e comportamental</strong>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <div className="flex items-center text-lg">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>Turnover baixo e alta satisfação</span>
              </div>
              <div className="flex items-center text-lg">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>Gestão contínua dos colaboradores</span>
              </div>
              <div className="flex items-center text-lg">
                <i className="ri-check-line text-green-400 mr-2"></i>
                <span>Treinamentos e benefícios</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Saiba Mais - Vídeo */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Conheça <span className="text-[#5D2FB3]">Outsourcing</span>
          </h2>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Descubra como nosso serviço de outsourcing oferece profissionais especializados 
            com gestão ativa e acompanhamento completo para o sucesso do seu projeto.
          </p>
          <button
            onClick={() => setShowVideoModal(true)}
            className="inline-flex items-center px-8 py-4 bg-[#3E296F] text-white font-semibold rounded-xl hover:bg-[#2D1F52] transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-2xl mr-3"></i>
            Assistir Vídeo de Apresentação
          </button>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Diferenciais do Nosso Outsourcing
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Conheça os diferenciais que fazem do nosso outsourcing a melhor escolha
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {diferenciais.map((diferencial, index) => (
              <div key={index} className="group">
                <div className="bg-gray-50 rounded-2xl p-6 h-full hover:bg-[#3E296F] transition-all duration-300 hover:shadow-xl hover:-translate-y-1 cursor-pointer">
                  <div className="w-12 h-12 bg-[#3E296F] rounded-xl flex items-center justify-center mb-4 group-hover:bg-white transition-colors duration-300">
                    <i className={`${diferencial.icon} text-2xl text-white group-hover:text-[#3E296F]`}></i>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-3 group-hover:text-white transition-colors duration-300">
                    {diferencial.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed group-hover:text-gray-200 transition-colors duration-300">
                    {diferencial.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cases de Sucesso */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Cases de Sucesso
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Empresas que já confiam em nossos profissionais especializados
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {cases.map((caso, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                <div className="flex items-center mb-6">
                  <img 
                    src={caso.logo} 
                    alt={caso.cliente}
                    className="h-12 w-auto object-contain"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {caso.cliente}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {caso.descricao}
                </p>
                <ul className="mt-4 space-y-2">
                  {caso.indicadores && caso.indicadores.map((indicador, idx) => (
                    <li key={idx} className="flex items-center text-gray-700 text-sm font-medium">
                      <i className="ri-check-line text-green-500 mr-2"></i>
                      {indicador}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-20 bg-[#3E296F]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Buscando profissionais especializados?
          </h2>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Entre em contato conosco e descubra como nosso outsourcing <br/> 
            pode fornecer os profissionais ideais para o seu projeto.
          </p>
          <button
            onClick={handleContactClick}
            className="inline-flex items-center px-8 py-4 bg-white text-[#3E296F] font-semibold rounded-xl hover:bg-gray-100 transition-all duration-300 hover:scale-105 hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line text-xl mr-3"></i>
            Falar com Especialista
          </button>
        </div>
      </section>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-6 max-w-2xl w-full">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold text-gray-900">Vídeo de Apresentação</h3>
              <button
                onClick={() => setShowVideoModal(false)}
                className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            <div className="bg-gray-100 rounded-xl p-8 text-center">
              <i className="ri-video-line text-4xl text-gray-400 mb-4"></i>
              <p className="text-gray-600">
                O vídeo de apresentação será disponibilizado em breve. 
                Entre em contato para mais informações.
              </p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default OutsourcingPage;